export default __webpack_public_path__ + "static/signature.1.0.0-black-85e7ec82db841118adc96d90430002c7.png";